import { Button, RefreshIcon, SmartToyIcon, Tooltip, Wrapper } from '@visualfabriq/vf-ui-kit';

import { FSMState } from 'src/api-new/bifrost';
import { getExecutionStatusIcon, getStatusColor, getStatusDisplayName } from 'src/containers/Pipelines/utils';
import { PipelineFilteredDTO } from 'src/dto/pipelines/Pipeline';

import { Link } from 'react-router-dom';

type Props = {
  pipeline: PipelineFilteredDTO;
};

const HISTORY_ITEMS_LENGTHS = 5;

export function HistoryColumn(props: Props) {
  const { pipeline } = props;

  return (
    <Wrapper alignItems="center" gap={200}>
      {pipeline.executions.slice(0, HISTORY_ITEMS_LENGTHS).map((execution) => {
        const Icon = getExecutionStatusIcon(execution.display_state ?? (execution.state as FSMState)) || SmartToyIcon;
        return (
          <Tooltip
            key={execution.datetime_started}
            content={getStatusDisplayName(execution.display_state ?? (execution.state as FSMState))}
          >
            <Icon size="20px" color={getStatusColor(execution.display_state ?? (execution.state as FSMState))} />
          </Tooltip>
        );
      })}
      <div style={{ marginLeft: 'auto' }}>
        <Tooltip content="Open History">
          <Link to={`${pipeline.id}/history`}>
            <Button kind="secondary">
              <RefreshIcon />
            </Button>
          </Link>
        </Tooltip>
      </div>
    </Wrapper>
  );
}
